import { authenticatedFetch } from "./http";

export interface ProcessTransferTask {
  id: string;
  handlingUnitId: string;
  huNumber: string;
  warehouseCode: string;
  sourcePointCode: string;
  destinationPointCode: string;
  transferType:
    | "QUALITY_TO_REPACKAGING"
    | "PUTAWAY_TO_QUALITY"
    | "STOCK_TO_QUARANTINE"
    | "PICKING_TO_OUTBOUND_REPACKAGING";
  status: "OPEN" | "IN_PROGRESS" | "EXCEPTION" | "COMPLETED" | "CANCELLED";
  assignedUserId: string | null;
  assignedUserName: string | null;
  createdAt: string;
  startedAt: string | null;
  completedAt: string | null;
  exceptionCode: string | null;
  exceptionComment: string | null;
  exceptionReportedAt: string | null;
  exceptionReportedByName: string | null;
  resolutionAction: string | null;
  resolutionComment: string | null;
  resolvedAt: string | null;
  version: number;
}

export function loadProcessTransfers(): Promise<ProcessTransferTask[]> {
  return authenticatedFetch<ProcessTransferTask[]>("/api/v1/process-transfers");
}

export function claimProcessTransfer(
  task: ProcessTransferTask
): Promise<ProcessTransferTask> {
  return authenticatedFetch<ProcessTransferTask>(
    `/api/v1/process-transfers/${task.id}/claim`,
    { method: "POST", body: JSON.stringify({ version: task.version }) }
  );
}

export function completeProcessTransfer(
  task: ProcessTransferTask
): Promise<ProcessTransferTask> {
  return authenticatedFetch<ProcessTransferTask>(
    `/api/v1/process-transfers/${task.id}/complete`,
    { method: "POST", body: JSON.stringify({ version: task.version }) }
  );
}

export function reportProcessTransferException(
  task: ProcessTransferTask, code: string, comment: string
): Promise<ProcessTransferTask> {
  return authenticatedFetch<ProcessTransferTask>(
    `/api/v1/process-transfers/${task.id}/report-exception`,
    {
      method: "POST",
      body: JSON.stringify({ code, comment, version: task.version })
    }
  );
}

export function resolveProcessTransferException(
  task: ProcessTransferTask, action: string, comment: string,
  destinationProcessPointId: string | null
): Promise<ProcessTransferTask> {
  return authenticatedFetch<ProcessTransferTask>(
    `/api/v1/process-transfers/${task.id}/resolve-exception`,
    {
      method: "POST",
      body: JSON.stringify({
        action, comment, destinationProcessPointId, version: task.version
      })
    }
  );
}
